import { useSnapshot } from 'reactish-state';
import { PreLoading as ThemedPreLoading } from '../../components/PreLoading';
import * as selectors from '../../stores/selectors';

export const PreLoading = () => {
    const isPreloading = useSnapshot(selectors.isPreloading);

    return <ThemedPreLoading state={isPreloading ? 'open' : 'close'} />;
};
